"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _excluded = ["adornment", "classes", "className", "getInputNative"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ChatInput = function ChatInput(_ref) {
  var adornment = _ref.adornment,
      classes = _ref.classes,
      className = _ref.className,
      getInputNative = _ref.getInputNative,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
    className: (0, _classnames["default"])(classes.root, className),
    InputProps: {
      disableUnderline: true,
      classes: {
        root: classes.input,
        inputMultiline: classes.inputMultiline
      },
      endAdornment: adornment && /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end",
        className: classes.adornment
      }, adornment)
    },
    inputRef: function inputRef(input) {
      return getInputNative(input);
    },
    multiline: true,
    fullWidth: true
  }, other));
};

var styles = function styles(theme) {
  return {
    root: {
      margin: '5px 0'
    },
    input: {
      boxSizing: 'border-box',
      alignItems: 'flex-end',
      padding: '8px 40px 9px 12px',
      border: "1px solid ".concat(theme.palette.divider),
      borderRadius: 19
    },
    inputMultiline: {
      overflow: 'hidden'
    },
    adornment: {
      position: 'absolute',
      right: -6,
      bottom: 18
    }
  };
};

ChatInput.propTypes = {
  adornment: _propTypes["default"].node,
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  getInputNative: _propTypes["default"].func.isRequired
};
ChatInput.defaultProps = {
  className: ''
};

var _default = (0, _styles.withStyles)(styles)(ChatInput);

exports["default"] = _default;